import { Subscribable } from 'rxjs';
import { isSubscribable } from '../../rxjs-utils';

import { MobizRuntimeError } from '../data/mobiz-runtime-error';

/**
 * @deprecated switch to IMobizErrorProxy from the error-proxy sub-package.
 */
export interface IMobizRuntimeErrorHandler {
  readonly errors$: Subscribable<MobizRuntimeError>;

  handleError(error: unknown): void;
}

/**
 * @deprecated IMobizRuntimeErrorHandler has been replaced by IMobizErrorProxy from the error-proxy sub-package.
 */
export function isMobizRuntimeErrorHandler(handler: unknown): handler is IMobizRuntimeErrorHandler {
  return typeof handler === 'object'
    && handler !== null
    && isSubscribable((handler as { errors$: unknown }).errors$)
    && typeof (handler as { handleError: unknown }).handleError === 'function';
}
